var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (this.isVisible)?_c('th',{class:_vm.headerClass,attrs:{"role":"columnheader","aria-sort":_vm.ariaSort,"aria-disabled":_vm.ariaDisabled},on:{"click":_vm.clicked}},[_vm._v("\n    "+_vm._s(_vm.label)+"\n")]):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3039b253","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/shared/table/components/TableColumnHeader.vue
// module id = null
// module chunks = 